const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const block = require('./block');
const getEntry = require('./contentful/entry-get');
const entryUpdate = require('./contentful/entry-update');
const update = require('immutability-helper');
const transformer = require('./transformers/make');
const linkResolve = require('./contentful/link-resolve');
const processError = require('./contentful/error-process');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getById(...parameters) {
    return gettingEntryService().then((service) => service.getById(...parameters));
  },

  all(depth = 0) {
    return getSpace().then((space) => {
      return space.getEntries({
        content_type: 'bilmerker', // eslint-disable-line
        order: 'sys.createdAt',
        limit: 999
      }).catch(
        processError
      ).then((entries) => {
        // Resolve links to linked resources (one level deep):
        return linkResolve(space, entries, depth).then((entries) => {
          return entries.items.map(transformer.contentfulToInternal);
        });
      });
    });
  },

  save(make, depth = 0) {
    return getSpace().then((space) => {
      return getEntry(space, make.id).then((entry) => {
        const data = entry.toPlainObject();
        let currentFrontpageContentLinks = [];

        if (data.fields.frontpageContent && data.fields.frontpageContent['nb-NO']) {
          currentFrontpageContentLinks = data.fields.frontpageContent['nb-NO'];
        }

        return block.saveBlockArray(currentFrontpageContentLinks, make.frontpageContent, false).then((newContent) => {
          const newMake = update(make, {
            frontpageContent: {
              $set: newContent
            }
          });

          const data = transformer.internalToContentful(newMake);
          return entryUpdate(entry, data);
        }).then((entry) => {
          const data = entry.toPlainObject();
          return linkResolve(space, data, depth);
        }).then((data) => {
          return transformer.contentfulToInternal(data);
        });
      });
    });
  },

  publishWithBlocks(make, depth) {
    const frontpageContentIdsToPublish = make.frontpageContent.reduce((ids, md) => {
      if (!md.published || md.updated) {
        ids.push(md.id);
      }

      return ids;
    }, []);

    if (!frontpageContentIdsToPublish.length) {
      return gettingEntryService().then((service) => service.publish(make.id, depth));
    }

    return block.publishBlocks(frontpageContentIdsToPublish).then(() => {
      return gettingEntryService().then((service) => service.publish(make.id, depth));
    });
  },

  select(fieldString) {
    return getSpace().then((space) => {
      return space.getEntries({
        content_type: 'bilmerker', // eslint-disable-line
        order: 'sys.createdAt',
        select: fieldString,
        limit: 999
      }).catch(
        processError
      );
    });
  }
};
